import React from 'react';
import styles from './Button.module.css';

const button = ({ text }) => {
  return <button className={styles.button}>{text}</button>;
};

export default button;
